export enum SnackbarActionTypes {
  ENQUEUE_SNACKBAR = '@@snackbar/ENQUEUE_SNACKBAR',
  CLOSE_SNACKBAR = '@@snackbar/CLOSE_SNACKBAR',
  REMOVE_SNACKBAR = '@@snackbar/REMOVE_SNACKBAR',
}
